<!--The content below is only a placeholder and can be replaced.-->
<div class="jumbotran">
    <div class="container-fluid">
        <!-- <app-header></app-header> -->
        <router-outlet></router-outlet>
    </div>
</div>
